// Lightweight wrapper around Google Analytics 4 (gtag.js).
// gtag.js is loaded from /public/index.html with measurement ID G-0DD34LNBRD.
// All custom events are funneled through trackEvent so we have a single
// source of truth and can swap providers later without touching components.

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', eventName, params);
  } catch (err) {
    // Never let analytics break the UI.
    // eslint-disable-next-line no-console
    console.warn('GA trackEvent failed:', err);
  }
};

// Convenience helpers — keep the event name + parameter shape consistent
// across the app so reports stay clean in the GA4 dashboard.

export const trackCtaClick = (cta, location, extra = {}) =>
  trackEvent('cta_click', {
    cta_name: cta,           // 'request_demo' | 'try_it_now' | 'watch_demo' | ...
    cta_location: location,  // 'header_desktop' | 'hero' | 'apps_top' | ...
    ...extra,
  });

export const trackStoreClick = (store, location) =>
  trackEvent('store_badge_click', {
    store,        // 'apple' | 'google'
    cta_location: location, // 'apps_top' | 'apps_hero' | 'apps_nfc'
  });

export const trackOutboundClick = (url, label, location) =>
  trackEvent('outbound_click', {
    link_url: url,
    link_label: label,
    cta_location: location,
  });

export const trackNavClick = (label, location) =>
  trackEvent('nav_click', {
    nav_label: label,           // 'Solutions' | 'Pricing' | 'App' | ...
    cta_location: location,     // 'header_desktop' | 'header_mobile' | 'footer'
  });
